import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, UntypedFormGroup, NgModelGroup } from '@angular/forms';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, CanLoad, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { AuthService } from './../../modulos/auth/services/auth.service';
import { AlertService } from './../../services/alert.service';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { Ambiente } from 'src/app/modulos/catalogos-proces/models/ambiente';
import * as globalAccions from "./../../redux/global/global.actions"
import * as userAccions from "./../../redux/usuario/usuario.actions"
import { UsuarioRedux } from 'src/app/models/usuario.model';
import { Rol } from 'src/app/modulos/admin/models/rol';
import { ModalService } from 'src/app/services/modal.service';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  //private buffer!: any;
  private currentUser!: any;
  idRolAmbiente!: any;

  public userLogued!: any;

  //Almacena la opcion seleccionada del combo box
  selectedOption: any;

  //Formulario de Combo Box
  public formSelectRolAmbiente!: FormGroup;

  //Almacena la lista de roles y ambientes del usuario actual
  dataUsuarioRolesAmbientes: Rol[];

  //Almacena el ambiente activo de Redux
  ambienteActivo: Ambiente = null;

  //Almacena la suscripción al ambiente Seleccionado en Redux
  ambienteSeleccionado: Ambiente = null;

  //Almacena el usuario actual disponible en Redux
  currentUserRedux: UsuarioRedux = null;

  //almacena el rol actual, relacionado con el Ambiente Seleccionado
  rolActivo: Rol = null;
  buffer: string;

  public nameModalObservador: string = 'modalObservador';
  public nameApp = 'OBSERVAR ELEMENTOS';
  readonly constant = ConstantsCatalogosIdService;
  public idRolObservador: number = 0;
  public idRolAnalistaMetodologico: number = 0;
  public idRolLinderMetodologico: number = 0;
  public idSprRolPrincipal: number = 0;



  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private store: Store<AppState>,
    public modal: ModalService,
    private router: Router
  ) {
    this.idRolObservador = this.constant.OBSERVADOR;
    this.idRolLinderMetodologico = this.constant.LIDER_METODOLOGICO;
    this.idRolAnalistaMetodologico = this.constant.ANALISTA_METODOLOGICO;

    this.store.select("usuarioApp").subscribe((response:any) => {
      this.currentUserRedux = response.currentUser;
      this.currentUser = response.currentUser;//JSON.parse(this.buffer);
      
      if (this.currentUserRedux) {
        this.dataUsuarioRolesAmbientes = this.currentUserRedux.roles
      }
    });
    this.store.select("globalApp").subscribe((response) => {
      this.ambienteSeleccionado = response.ambienteSeleccionado;
      this.rolActivo = response.rolSeleccionado;
      this.rolActivo = this.currentUserRedux.roles.find(({ ambiente }) => ambiente.idSprAmbiente === this.ambienteSeleccionado.idSprAmbiente)
      this.idSprRolPrincipal = response.rolSeleccionado.idSprRol;
    });
    this.setRolAmbiente();
  }


  ngOnInit(): void {
    this.setSelectAmbienteRol();
  }

  /**
   * Fija el valor por defecto seleccionado del combo box para el rol y ambiente activos
   */
  setRolAmbiente() {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.selectedOption = this.currentUser.idSprRol + "*" + this.currentUser.idSprAmbiente + "*" + this.currentUser.nombreUnidad + "*" + this.currentUser.idSprNivel;   
  }


  //Método invocado desde el Template para renderizar el Rol y Ambiente Seleccionado

  setSelectAmbienteRol() {
    this.formSelectRolAmbiente = this.fb.group({
      idSprRolAmbiente: [this.selectedOption]
    });
  }

  /**
   * * idAmbienteCombo -> captura del evento combo el valor separado por * en la posición 1 es decir idSprAmbiente
     * ambienteActivo -> Almacena el ambiente obtenido de la selección del combo y filtrado en los roles del usuario actual
     * Dispara al redux el cambio de ambiente, y las suscripciones a ambienteSeleccionado reconstruyen sus funciones
   * @param e evento que dispara el change del combo box
   */
  changeRolAmbienteSelected(e: any) {
    let idRolActual = e.target.value.split('*')[0];
    let idAmbienteCombo = e.target.value.split('*')[1]

    if (this.currentUserRedux) {
      this.rolActivo = this.dataUsuarioRolesAmbientes.find((rol) => (rol.idSprRol === parseInt(idRolActual)) && (rol.ambiente.idSprAmbiente === parseInt(idAmbienteCombo)));
      this.store.dispatch(globalAccions.ambienteSeleccionado({ ambiente: this.rolActivo.ambiente, rol: this.rolActivo }))
    }

    this.idRolAmbiente = e.target.value.split('*');
    this.currentUser.idSprRol = this.idRolAmbiente[0];
    this.currentUser.idSprAmbiente = this.idRolAmbiente[1];
    this.currentUser.nombreUnidad = this.idRolAmbiente[2];
    this.currentUser.idSprNivel = this.idRolAmbiente[3];

    localStorage.setItem("currentUser", JSON.stringify(this.currentUser));
    window.location.reload();
  }

  /**
   * Función para cerrar sesión de usuario
   */
  logout() {
    //Invoca al método para cambiar el currentUser del behaivor Subject a null         
    this.authService.logout();
    //Dispara el store para cambiar el estado de la aplicación a sin sessión.
    this.store.dispatch(userAccions.logout())
    this.router.navigate(['login/auth']);
  }

  openModal() {
    this.modal.openObservador(this.nameModalObservador);
  }

  closeModal() {
    this.modal.closeId(this.nameModalObservador);
    window.location.reload();
  }

}
